/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChainOption } from './ChainOption';
import {
    ChainOptionFromJSON,
    ChainOptionFromJSONTyped,
    ChainOptionToJSON,
    ChainOptionToJSONTyped,
} from './ChainOption';
import type { SearchDatesV2 } from './SearchDatesV2';
import {
    SearchDatesV2FromJSON,
    SearchDatesV2FromJSONTyped,
    SearchDatesV2ToJSON,
    SearchDatesV2ToJSONTyped,
} from './SearchDatesV2';
import type { SearchLocationV2 } from './SearchLocationV2';
import {
    SearchLocationV2FromJSON,
    SearchLocationV2FromJSONTyped,
    SearchLocationV2ToJSON,
    SearchLocationV2ToJSONTyped,
} from './SearchLocationV2';

/**
 * 
 * @export
 * @interface PortfolioOptimizationResult
 */
export interface PortfolioOptimizationResult {
    /**
     * 
     * @type {Array<ChainOption>}
     * @memberof PortfolioOptimizationResult
     */
    chainOptions: Array<ChainOption>;
    /**
     * 
     * @type {ChainOption}
     * @memberof PortfolioOptimizationResult
     */
    bestOption?: ChainOption;
    /**
     * Number of chains searched
     * @type {number}
     * @memberof PortfolioOptimizationResult
     */
    userChainsSearched: number;
    /**
     * 
     * @type {SearchLocationV2}
     * @memberof PortfolioOptimizationResult
     */
    searchLocation?: SearchLocationV2;
    /**
     * 
     * @type {SearchDatesV2}
     * @memberof PortfolioOptimizationResult
     */
    searchDates?: SearchDatesV2;
}

/**
 * Check if a given object implements the PortfolioOptimizationResult interface.
 */
export function instanceOfPortfolioOptimizationResult(value: object): value is PortfolioOptimizationResult {
    if (!('chainOptions' in value) || value['chainOptions'] === undefined) return false;
    if (!('userChainsSearched' in value) || value['userChainsSearched'] === undefined) return false;
    return true;
}

export function PortfolioOptimizationResultFromJSON(json: any): PortfolioOptimizationResult {
    return PortfolioOptimizationResultFromJSONTyped(json, false);
}

export function PortfolioOptimizationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioOptimizationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'chainOptions': ((json['chain_options'] as Array<any>).map(ChainOptionFromJSON)),
        'bestOption': json['best_option'] == null ? undefined : ChainOptionFromJSON(json['best_option']),
        'userChainsSearched': json['user_chains_searched'],
        'searchLocation': json['search_location'] == null ? undefined : SearchLocationV2FromJSON(json['search_location']),
        'searchDates': json['search_dates'] == null ? undefined : SearchDatesV2FromJSON(json['search_dates']),
    };
}

export function PortfolioOptimizationResultToJSON(json: any): PortfolioOptimizationResult {
    return PortfolioOptimizationResultToJSONTyped(json, false);
}

export function PortfolioOptimizationResultToJSONTyped(value?: PortfolioOptimizationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chain_options': ((value['chainOptions'] as Array<any>).map(ChainOptionToJSON)),
        'best_option': ChainOptionToJSON(value['bestOption']),
        'user_chains_searched': value['userChainsSearched'],
        'search_location': SearchLocationV2ToJSON(value['searchLocation']),
        'search_dates': SearchDatesV2ToJSON(value['searchDates']),
    };
}

